import $ from 'jquery';

/**
 * @desc Toggles between a compact (shows only N items) and full views of feed filters.
 */
export default class FeedFilters {
  constructor(widgetSelector, switchButtonSelector = '.js-feed-filters-toggle') {
    this.$widget = $(widgetSelector);
    this.$switchButton = this.$widget.find(switchButtonSelector);

    this.init();
  }

  init() {
    this.isInitialized = true;

    if (!this.$widget.length || !this.$switchButton.length) {
      this.isInitialized = false;

      return;
    }

    this.attachEventListeners();
  }

  /**
   * @desc Add event listeners to filters' controls.
   */
  attachEventListeners() {
    this.$switchButton.click(() => {
      this.$widget.toggleClass('is-expanded');
    });
  }
}
